module.exports = __webpack_public_path__ + "static/media/globe_bg.db6ef2a0.jpg";